var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "slider-item" }, [
    _c("h3", { ref: "title", staticClass: "slider-item__title" }, [
      _vm._v(_vm._s(_vm.question))
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }